import type { AppointmentStatus } from '@bb/domain/dist/types';
import axios from 'axios';

const timeChange = async (
  appointmentId: string,
  options: {
    date: string;
    time: Date;
    timeEnd: Date;
  },
  getUpdatedStatus?: boolean,
): Promise<{
  status?: AppointmentStatus;
  isPending?: boolean;
  displayStatus?: string;
}> => {
  const { data } = await axios.post(
    `/appointments/${appointmentId}/time_change`,
    { ...options, getUpdatedStatus },
  );
  return data || {};
};

export default timeChange;
